export default {
	"order.MallOpeningRecordPage": "商城開通記錄頁",
	"order.PhasesOpened": "已開通期數：",
	"order.StoreOpeningRecordPageBuyTheNextIssueClick": "商城開通記錄頁_購買下期點擊",
	"order.buyNextIssue": "購買下期",
	"order.DebitRecord": "扣款記錄",
	"order.No": "不。",
	"order.Expect": "期",
	"order.DebitSuccess": "扣款成功",
	"order.D": "扣款金額：",
	"order.PaymentSerialNumber": "支付流水號：",
	"order.PaymentTime": "支付時間：",
	"order.UnfortunatelyNoMatchingDataWasFound": "非常遺憾，沒有找到符合條件的數據"
}